// Account-wide settings the shell writes; the workspace's facility scope lives here.
import { baseApi } from './baseApi';
import { TAG_TYPE_LIST } from './tags';
import { FACILITY_KINDS, parseFacilityValue } from '@/config/formOptions';
import { ALL_FACILITIES, parseTerminalValue } from '@/config/workspaceFacilities';

const PATHS = {
  selectFacility: '/account/select-storage-or-site',
};

/**
 * The server takes at most one facility and reads all-null as "every facility", so a kind
 * that is not picked travels as null rather than being omitted — the query nulls what it
 * is not given (updateSelectedStorageOrSiteQuery, iscc-backend). A terminal travels with
 * its site, which the server checks it belongs to; any other pick clears the terminal.
 */
export const toFacilityBody = (value) => {
  const terminal = parseTerminalValue(value);
  if (terminal) {
    return {
      selectedSiteId: terminal.siteId,
      selectedStorageId: null,
      selectedBackToBackAccountId: null,
      selectedTerminalId: terminal.terminalId,
    };
  }
  const { kind, id } =
    value === ALL_FACILITIES ? { kind: null, id: null } : parseFacilityValue(value);
  return {
    selectedSiteId: kind === FACILITY_KINDS.site ? id : null,
    selectedStorageId: kind === FACILITY_KINDS.storage ? id : null,
    selectedBackToBackAccountId: kind === FACILITY_KINDS.backToBack ? id : null,
    selectedTerminalId: null,
  };
};

export const accountApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // Every list is scoped to the facility server-side, so the whole cache is stale after.
    selectFacility: build.mutation({
      query: (value) => ({
        url: PATHS.selectFacility,
        method: 'PATCH',
        body: toFacilityBody(value),
      }),
      invalidatesTags: TAG_TYPE_LIST,
    }),
  }),
});

export const { useSelectFacilityMutation } = accountApi;
